import { useTranslation } from '@conekta/cronos/i18n';
import { Select } from 'app/components/Select/Select';
import { Error } from 'app/pages/frames/components/Form/Error';
import { composeValidators } from 'app/pages/frames/util/validations';
import { Field } from 'react-final-form';

import { IFieldSelectEvaluated } from './interface';

export const FieldSelectEvaluated = ({
  disabled,
  id = '',
  options,
  styles,
  tRootLabelTexts,
  validations = [],
  onChange,
  tooltipHelper,
}: IFieldSelectEvaluated) => {
  const { t } = useTranslation();

  return (
    <Field classNameFieldSet={id} name={id} validate={composeValidators(...validations)}>
      {({ input }) => (
        <div className="field-wrapper__select">
          <Select
            {...{ disabled, input, options, styles }}
            labelOptions={{ text: t(`${tRootLabelTexts}.${id}`) }}
            isSearchable
            name={id}
            placeholder=""
            onChange={onChange}
            tooltipHelper={tooltipHelper}
          />
          <Error name={id} />
        </div>
      )}
    </Field>
  );
};
